import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  sv: {
    translation: {
      nav: {
        home: 'Hem',
        services: 'Tjänster',
        about: 'Om oss',
        contact: 'Kontakt',
        location: 'Hitta hit'
      },
      hero: {
        title: 'Värmdö Hörsel',
        subtitle: 'Din privata hörselmottagning på Värmdö',
        cta: 'Boka tid'
      },
      home: {
        servicesTitle: 'Våra tjänster',
        moreInfo: 'Mer info',
        horseltest: 'Hörseltest',
        horapparater: 'Hörapparater',
        service: 'Service och justering',
        yrkesliv: 'Hörselteknik i yrkeslivet',
        horselskydd: 'Formgjutna hörselskydd',
        dropinTitle: 'Drop-in för service av hörapparater',
        dropinSubtitle: 'Snabbt och smidigt',
        dropinHours: 'Mån–Tor, 9–12, 13–16',
        teamTitle: 'Om oss',
        teamText1: 'Vi är två legitimerade audionomer med över 50 års samlad erfarenhet inom hörselvård. Vårt arbete präglas av noggrannhet, lyhördhet och en stark vilja att erbjuda service av högsta kvalitet. Genom vår långa erfarenhet vet vi hur viktigt det är att varje individ bemöts med omtanke och professionellt stöd.',
        teamText2: 'Vi arbetar effektivt och utan väntetider för att du snabbt ska få den hjälp du behöver. Tillgänglighet är en av våra hjärtefrågor, och vi strävar alltid efter att finnas där för dig när du behöver oss.',
        teamText3: 'Välkommen att boka en tid hos oss – vi ser fram emot att hjälpa dig.',
        teamSignature: 'Lena Dahl och Roger Olsson',
        readMore: 'Läs mer om oss'
      },
      services: {
        title: 'Hörapparatutprovning',
        horapparater: 'Hörapparater',
        horapparaterDesc: 'Vi erbjuder ett brett sortiment av moderna hörapparater från ledande tillverkare.',
        ourServices: 'Våra tjänster inkluderar:',
        horseltest: 'Hörseltest och konsultation',
        anpassning: 'Professionell anpassning och programmering',
        provperiod: 'Provperiod på 30 dagar',
        uppfoljning: 'Uppföljning och justering',
        rengoring: 'Rengöring och underhåll',
        garanti: '3 års garanti på alla hörapparater',
        pricesFrom: 'Priser per par:',
        bas: 'Bas',
        basDesc: 'för samtal i lugna vardagsmiljöer',
        basPlus: 'Bas Plus',
        basPlusDesc: 'för samtal i lugna vardagsmiljöer med utökade funktioner',
        avancerad: 'Avancerad',
        avanceradDesc: 'för hörselstöd i miljöer med varierande ljudnivåer',
        premium: 'Premium',
        premiumDesc: 'för bästa möjliga hörselstöd i alla situationer',
        serviceTitle: 'Service & Justering',
        serviceDesc: 'Vi erbjuder professionell justering och optimering samt service och reparation av alla typer av hörapparater, oavsett fabrikat eller var de ursprungligen köpts.',
        serviceServices: 'Våra servicetjänster:',
        parkoppling: 'Parkoppling: Hörapparat - Mobil',
        grundligRengoring: 'Grundlig rengöring och kontroll',
        omprogrammering: 'Programmering, justering & optimering av hörapparater',
        byteFilter: 'Byte av filter och domer',
        servicePrices: 'Servicepriser:',
        serviceHorapparat: 'Service av Hörapparat*',
        justering: 'Hörapparat Justering/Årskontroll - hörselmätningar, uppdatering och optimering',
        serviceNote: '* Tillägg för byte av delar eller en reparation.',
        serviceBookDesc: 'Kontakta oss om du behöver hjälp med service av din hörapparat.',
        bookTitle: 'Boka din tid idag',
        bookDesc: '',
        call: 'Ring',
        bookTime: 'Boka tid',
        horapparatModeller: 'Hörapparatsmodeller',
        horapparatModellerDesc: 'Se vårt utbud av hörapparater →'
      },
      horseltest: {
        title: 'Hörseltest',
        subtitle: 'Professionell hörselundersökning',
        text1: 'Hos Värmdö Hörsel utför vi noggranna hörselundersökningar av legitimerade Audionomer med hjälp av toppmodern utrustning.',
        text2: 'Undersökningen syftar till att bedöma hörselförmågan, samt identifiera eventuella hörselnedsättningar.',
        text3: 'Genom regelbundna hörseltester kan en hörselnedsättning upptäckas i ett tidigt skede. Detta gör det möjligt att vidta rätt åtgärder i tid, vilket bidrar till god hörselhälsa och förbättrad livskvalitet.',
        bookTitle: 'Boka din tid idag',
        bookDesc: 'Kontakta oss för att boka ett hörseltest.',
        bookButton: 'Boka hörseltest'
      },
      horselskydd: {
        title: 'Formgjutna Hörselskydd',
        subtitle: 'Skräddarsytt skydd för din hörsel',
        text1: 'Vi erbjuder formgjutna hörselskydd anpassade för olika miljöer och behov. Oavsett om du arbetar i bullriga miljöer, spelar musik eller vill skydda hörseln under sömnen, har vi en lösning för dig.',
        text2: 'Våra hörselskydd tillverkas efter en individuell avgjutning av din hörselgång, vilket ger optimal passform och komfort. Det garanterar ett effektivt skydd utan att kompromissa med ljudkvaliteten.',
        bookTitle: 'Boka din tid idag',
        bookDesc: 'Kontakta oss för att boka en tid för avgjutning av dina personliga hörselskydd.'
      },
      horapparater: {
        title: 'Hörapparater',
        subtitle: '',
        intro: 'Vi erbjuder ett brett utbud av hörapparater från ledande tillverkare. Vi hjälper dig att hitta den hörapparat som passar dina behov och livsstil. Nedan presenteras ett axplock ur den senaste hörapparattekniken.'
      },
      about: {
        title: 'Om Värmdö Hörsel',
        intro: 'Värmdö Hörsel är en privat hörselmottagning belägen i vackra Gustavsbergs Hamn på Värmdö.',
        missionTitle: 'Vår mission',
        missionText: 'Vi strävar efter att ge varje kund den bästa möjliga hörselvården genom personlig service, modern teknik och gedigen expertis.',
        teamTitle: 'Vårt team',
        teamText: 'Vårt team består av legitimerade audionomer med lång erfarenhet inom hörselvård. Vi tar oss tid att lyssna på dina behov och hitta den lösning som passar dig bäst.',
        whyTitle: 'Varför välja oss?',
        why1: 'Personlig service och individuell anpassning',
        why2: 'Modern utrustning och senaste tekniken',
        why3: 'Legitimerade audionomer med lång erfarenhet',
        why4: 'Centralt läge i Gustavsberg',
        why5: 'Flexibla öppettider'
      },
      contact: {
        title: 'Kontakta oss',
        intro: 'Vi finns här för att hjälpa dig med alla frågor om hörsel och hörapparater.',
        phone: 'Telefon',
        email: 'E-post',
        address: 'Adress',
        hours: 'Öppettider',
        monThu: 'Måndag - Torsdag',
        fri: 'Fredag',
        sat: 'Lördag',
        sun: 'Söndag',
        closed: 'Stängt',
        formTitle: 'Skicka meddelande',
        name: 'Namn',
        emailLabel: 'E-post',
        phoneLabel: 'Telefon',
        message: 'Meddelande',
        consent: 'Jag godkänner att mina personuppgifter behandlas enligt',
        privacyPolicy: 'integritetspolicyn',
        send: 'Skicka meddelande',
        sending: 'Skickar...',
        success: 'Tack! Ditt meddelande har skickats.',
        error: 'Något gick fel. Försök igen.'
      },
      location: {
        title: 'Hitta hit',
        address: 'Adress',
        directions: 'Vägbeskrivning',
        directionsText: 'Vi finns i Gustavsbergs Värdshus, centralt beläget i Gustavsberg.',
        parking: 'Parkering',
        parkingText: 'Gratis parkering finns tillgänglig vid Gustavsbergs Värdshus.',
        publicTransport: 'Kollektivtrafik',
        publicTransportText: 'Buss 474 från Slussen stannar vid Gustavsbergs Hamn, ca 5 minuters promenad.'
      },
      footer: {
        quickLinks: 'Snabblänkar',
        contactInfo: 'Kontaktinfo',
        hours: 'Öppettider',
        rights: 'Alla rättigheter förbehållna.',
        privacy: 'Integritetspolicy',
        terms: 'Användarvillkor'
      },
      privacy: {
        title: 'Integritets- och personuppgiftspolicy',
        company: 'Värmdö Hörsel AB',
        intro: 'På Värmdö Hörsel AB värnar vi om din integritet och hanterar dina personuppgifter på ett säkert sätt. Vi följer Patientdatalagen, Patientjournallagen och GDPR.',
        journalTitle: 'Personuppgifter i patientjournaler',
        journalText: 'När du får vård hos oss dokumenteras dina uppgifter i en patientjournal, till exempel namn, personnummer, kontaktuppgifter, undersökningsresultat och medicinsk historik. Journalen lagras säkert i vårt journalsystem och endast behörig personal har åtkomst. Dessa uppgifter måste bevaras enligt lag.',
        bookingTitle: 'Personuppgifter i bokningssystem',
        bookingText: 'När du bokar tid hos oss sparas dina kontaktuppgifter och information om din bokning. Dessa uppgifter omfattas av patientjournallagen när de är kopplade till ditt vårdärende och hanteras med samma höga säkerhet.',
        usageTitle: 'Hur används uppgifterna?',
        usageIntro: 'Vi använder personuppgifter för att:',
        usage1: 'kunna ge dig vård och genomföra hörselutredningar,',
        usage2: 'administrera bokningar och kontakt,',
        usage3: 'uppfylla lagkrav inom hälso- och sjukvård.',
        usageNote: 'Vi använder aldrig dina uppgifter i marknadsföringssyfte utan ditt samtycke.',
        securityTitle: 'Säkerhet',
        securityText: 'Vi använder säkra system, åtkomstkontroller och skyddade kommunikationsvägar. Endast personal med vårdrelaterat behov får ta del av dina uppgifter.',
        rightsTitle: 'Dina rättigheter',
        rightsIntro: 'Du har rätt att:',
        rights1: 'få tillgång till din journal,',
        rights2: 'få felaktiga uppgifter rättade,',
        rights3: 'begära information om hur dina uppgifter används,',
        rights4: 'få loggutdrag över journalåtkomst.',
        rightsNote: 'Journaluppgifter kan inte tas bort på grund av lagkrav.',
        contactTitle: 'Kontakt',
        contactIntro: 'Har du frågor om hur vi hanterar personuppgifter är du välkommen att kontakta oss:'
      },
      terms: {
        title: 'Användarvillkor',
        comingSoon: 'Innehåll kommer snart.'
      },
      arbetshjalpmedel: {
        title: 'Hörselteknik för yrkeslivet',
        intro: 'Trots avancerad teknik i hörapparater i dag kan vissa arbetssituationer vara utmanande att höra i som tex möten, konferenser och video/telefonsamtal.',
        text1: 'För att höra bättre på arbetsplatsen kan du behöva ytterligare hörseltekniska hjälpmedel.',
        text2: 'Som yrkesverksam kan du ofta få bidrag för dessa via Försäkringskassan/Arbetsförmedlingen.',
        contactButton: 'Kontakta oss för mer information'
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: 'Home',
        services: 'Services',
        about: 'About',
        contact: 'Contact',
        location: 'Find us'
      },
      hero: {
        title: 'Värmdö Hearing',
        subtitle: 'Your private hearing clinic in Värmdö',
        cta: 'Book appointment'
      },
      home: {
        servicesTitle: 'Our services',
        moreInfo: 'More info',
        horseltest: 'Hearing test',
        horapparater: 'Hearing aids',
        service: 'Service & Repair',
        yrkesliv: 'Hearing technology for work',
        horselskydd: 'Custom ear protection',
        teamTitle: 'Our team',
        teamText1: 'With over 40 years of combined experience in hearing care, we are dedicated to helping you hear better.',
        teamText2: 'Our team consists of licensed audiologists who are passionate about providing you with the best possible hearing care.',
        readMore: 'Read more about us'
      },
      services: {
        title: 'Hearing aid fitting',
        horapparater: 'Hearing aids',
        horapparaterDesc: 'We offer a wide range of modern hearing aids from leading manufacturers.',
        ourServices: 'Our services include:',
        horseltest: 'Hearing test and consultation',
        anpassning: 'Professional fitting and programming',
        provperiod: '30-day trial period',
        uppfoljning: 'Follow-up and adjustment',
        rengoring: 'Cleaning and maintenance',
        garanti: '3-year warranty on all hearing aids',
        pricesFrom: 'Prices per pair:',
        bas: 'Basic',
        basDesc: 'for conversations in quiet everyday environments',
        basPlus: 'Basic Plus',
        basPlusDesc: 'for conversations in quiet everyday environments with extended features',
        avancerad: 'Advanced',
        avanceradDesc: 'for hearing support in environments with varying noise levels',
        premium: 'Premium',
        premiumDesc: 'for the best possible hearing support in all situations',
        serviceTitle: 'Service & Repair',
        serviceDesc: 'We offer professional service and repair of all types of hearing aids, regardless of brand or where they were originally purchased.',
        serviceServices: 'Our service offerings:',
        parkoppling: 'Pairing: Hearing aid - Mobile',
        grundligRengoring: 'Thorough cleaning and inspection',
        omprogrammering: 'Reprogramming and adjustment',
        byteFilter: 'Replacement of filters and domes',
        servicePrices: 'Service prices:',
        serviceHorapparat: 'Hearing aid service*',
        justering: 'Hearing aid adjustment/Annual check - hearing measurements, update and optimization',
        serviceNote: '* Additional charge for replacement parts or repair.',
        serviceBookDesc: 'Contact us if you need help with service of your hearing aid.',
        bookTitle: 'Book your appointment today',
        bookDesc: 'Contact us to book a free consultation or hearing test.',
        call: 'Call',
        bookTime: 'Book appointment',
        horapparatModeller: 'Hearing aid models',
        horapparatModellerDesc: 'See our range of hearing aids →'
      },
      horseltest: {
        title: 'Hearing test',
        subtitle: 'Professional hearing examination',
        text1: 'At Värmdö Hörsel, we perform thorough hearing examinations by licensed audiologists using state-of-the-art equipment.',
        text2: 'The examination aims to assess hearing ability and identify any hearing impairments.',
        bookTitle: 'Book your appointment today',
        bookDesc: 'Contact us to book a free consultation or hearing test.',
        bookButton: 'Book hearing test'
      },
      horselskydd: {
        title: 'Custom ear protection',
        subtitle: 'Tailored protection for your hearing',
        text1: 'We offer custom-molded ear protection adapted for different environments and needs. Whether you work in noisy environments, play music, or want to protect your hearing during sleep, we have a solution for you.',
        text2: 'Our ear protection is manufactured from an individual mold of your ear canal, providing optimal fit and comfort. This guarantees effective protection without compromising sound quality.',
        bookTitle: 'Book your appointment today',
        bookDesc: 'Contact us to book an appointment for molding your personal ear protection.'
      },
      about: {
        title: 'About Värmdö Hörsel',
        intro: 'Värmdö Hörsel is a private hearing clinic located in beautiful Gustavsberg on Värmdö.',
        missionTitle: 'Our mission',
        missionText: 'We strive to provide every customer with the best possible hearing care through personal service, modern technology, and solid expertise.',
        teamTitle: 'Our team',
        teamText: 'Our team consists of licensed audiologists with extensive experience in hearing care. We take the time to listen to your needs and find the solution that suits you best.',
        whyTitle: 'Why choose us?',
        why1: 'Personal service and individual customization',
        why2: 'Modern equipment and latest technology',
        why3: 'Licensed audiologists with extensive experience',
        why4: 'Central location in Gustavsberg',
        why5: 'Flexible opening hours'
      },
      contact: {
        title: 'Contact us',
        intro: 'We are here to help you with all questions about hearing and hearing aids.',
        phone: 'Phone',
        email: 'Email',
        address: 'Address',
        hours: 'Opening hours',
        monThu: 'Monday - Thursday',
        fri: 'Friday',
        sat: 'Saturday',
        sun: 'Sunday',
        closed: 'Closed',
        formTitle: 'Send message',
        name: 'Name',
        emailLabel: 'Email',
        phoneLabel: 'Phone',
        message: 'Message',
        consent: 'I agree that my personal data will be processed according to the',
        privacyPolicy: 'privacy policy',
        send: 'Send message',
        sending: 'Sending...',
        success: 'Thank you! Your message has been sent.',
        error: 'Something went wrong. Please try again.'
      },
      location: {
        title: 'Find us',
        address: 'Address',
        directions: 'Directions',
        directionsText: 'We are located in Gustavsbergs Värdshus, centrally located in Gustavsberg.',
        parking: 'Parking',
        parkingText: 'Free parking is available at Gustavsbergs Värdshus.',
        publicTransport: 'Public transport',
        publicTransportText: 'Bus 474 from Slussen stops at Gustavsbergs Hamn, about 5 minutes walk.'
      },
      footer: {
        quickLinks: 'Quick links',
        contactInfo: 'Contact info',
        hours: 'Opening hours',
        rights: 'All rights reserved.',
        privacy: 'Privacy policy',
        terms: 'Terms of use'
      },
      privacy: {
        title: 'Privacy and personal data policy',
        company: 'Värmdö Hörsel AB',
        intro: 'At Värmdö Hörsel AB, we care about your privacy and handle your personal data securely. We follow the Patient Data Act, the Patient Records Act, and GDPR.',
        journalTitle: 'Personal data in patient records',
        journalText: 'When you receive care from us, your information is documented in a patient record, such as name, personal identification number, contact details, examination results, and medical history. The record is stored securely in our record system and only authorized personnel have access. This data must be retained according to law.',
        bookingTitle: 'Personal data in booking systems',
        bookingText: 'When you book an appointment with us, your contact details and booking information are saved. This data is covered by the Patient Records Act when linked to your care matter and is handled with the same high security.',
        usageTitle: 'How is the data used?',
        usageIntro: 'We use personal data to:',
        usage1: 'provide you with care and conduct hearing examinations,',
        usage2: 'manage bookings and contact,',
        usage3: 'fulfill legal requirements in healthcare.',
        usageNote: 'We never use your data for marketing purposes without your consent.',
        securityTitle: 'Security',
        securityText: 'We use secure systems, access controls, and protected communication channels. Only staff with care-related needs may access your data.',
        rightsTitle: 'Your rights',
        rightsIntro: 'You have the right to:',
        rights1: 'access your medical records,',
        rights2: 'have incorrect data corrected,',
        rights3: 'request information about how your data is used,',
        rights4: 'receive log extracts of record access.',
        rightsNote: 'Medical record data cannot be deleted due to legal requirements.',
        contactTitle: 'Contact',
        contactIntro: 'If you have questions about how we handle personal data, please contact us:'
      },
      terms: {
        title: 'Terms of use',
        comingSoon: 'Content coming soon.'
      },
      arbetshjalpmedel: {
        title: 'Hearing technology for work',
        intro: 'Despite advanced technology in today\'s hearing aids, some work situations can be challenging to hear in, such as meetings, conferences, and video/phone calls.',
        text1: 'To hear better at work, you may need additional hearing technology aids.',
        text2: 'As a working professional, you can often get subsidies for these through the Swedish Social Insurance Agency/Employment Service.',
        contactButton: 'Contact us for more information'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'sv',
    fallbackLng: 'sv',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
